export default __webpack_public_path__ + "static/media/Abel-Regular.4cb2c892.woff2";